<template>
    <div>
        <div class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center profile-header"
             style="min-height: 200px;">
            <b-container fluid>
                <span class="mask bg-gradient-success opacity-8"></span>
            </b-container>
        </div>
        <b-container v-if="isLoading" fluid class="mt--7">
            <card>
                <h3>Job history loading...</h3>
            </card>
        </b-container>
        <b-container v-else fluid class="mt--7">
            <card>
                <b-row>
                    <b-col>
                        <h4>Job name:</h4>
                        <p>{{jobHistory.job.name}}</p>
                    </b-col>
                    <b-col>
                        <h4>Job log ID:</h4>
                        <p>{{jobHistory.id}}</p>
                    </b-col>
                    <b-col>
                        <h4>Domain name:</h4>
                        <router-link :to="'/domain/'+jobHistory.job.domain.id" target='_blank'>
                            <p>{{jobHistory.job.domain.name}}</p>
                        </router-link>
                    </b-col>
                    <b-col>
                        <h4>Domain address:</h4>
                        <a :href="jobHistory.job.domain.domain_address" target="_blank"><p>{{jobHistory.job.domain.domain_address}}</p></a>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h4>Start time:</h4>
                        <p>{{jobHistory.start_time===undefined || jobHistory.start_time===null ? ' ' : formatDefaultDate(timestampToDatetime(jobHistory.start_time))}}</p>
                    </b-col>
                    <b-col>
                        <h4>Status:</h4>
                        <p>{{jobLogStatusDescriptions[jobHistory.status]}}</p>
                    </b-col>
                    <b-col>
                        <h4>End time:</h4>
                        <p>{{jobHistory.end_time===undefined || jobHistory.end_time===null ? ' ' : formatDefaultDate(timestampToDatetime(jobHistory.end_time))}}</p>
                    </b-col>
                    <b-col>
                        <h4>Time elapsed:</h4>
                        <p>{{calculateElapsedTime(jobHistory.start_time,jobHistory.end_time)}}</p>
                    </b-col>
                </b-row>
                <card>
                    <b-row>
                        <b-col>
                            <h3>Results</h3>
                        </b-col>
                        <b-col></b-col>
                        <b-col>
                            <button class="btn btn-success" @click="downloadResults()">
                                <template v-if="!isDownloading">Download</template>
                                <template v-else>Downloading...</template> <!-- TODO: Alttaki ikonun animasyonunu düzelt ve onu kullan -->
                                <!-- <b-icon v-else icon="arrow-clockwise" animation="spin" font-scale="2"></b-icon> -->
                            </button>
                        </b-col>
                        <b-col>
                            <base-button icon type="info" @click="switchJobResults()">
                                <span class="btn-inner--icon">
                                    <i :class="{'ni ni-fat-add':!showJobResults, 'ni ni-fat-delete':showJobResults}" />
                                </span>
                            </base-button>
                        </b-col>
                    </b-row>
                    <br>
                    <template v-if="showJobResults">
                        <result-table v-if="jobHistory.result!==undefined && jobHistory.result!==null" :data="jobHistory.result" />
                        <p v-else>Loading results...</p>
                    </template>
                    
                </card>
                <card>
                    <h3>Operation logs:</h3>
                    <card v-if="operationLogsLoading">
                        <h3>Loading...</h3>
                    </card>
                    <template v-else>
                        <card v-for="(log,index) in operationLogs" :key="'oplog-'+index">
                            <b-row>
                                <b-col>
                                    <h4>Name:</h4>
                                    <p>{{log.operation}}</p>
                                </b-col>
                                <b-col>
                                    <h4>Log ID:</h4>
                                    <p>{{log.id}}</p>
                                </b-col>
                                <b-col>
                                    <h4>Start time:</h4>
                                    <p>{{log.start_time===undefined || log.start_time===null ? ' ' : formatDefaultDate(timestampToDatetime(log.start_time))}}</p>
                                </b-col>
                                <b-col>
                                    <h4>Status:</h4>
                                    <p>{{operationLogStatusDescriptions[log.status]}}</p>
                                </b-col>
                                <b-col>
                                    <h4>End time:</h4>
                                    <p>{{log.end_time===undefined || log.end_time===null ? ' ' : formatDefaultDate(timestampToDatetime(log.end_time))}}</p>
                                </b-col>
                                <b-col>
                                    <h4>Time elapsed:</h4>
                                    <p>{{calculateElapsedTime(log.start_time,log.end_time)}}</p>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <h3>Results:</h3>
                                </b-col>
                                <b-col></b-col>
                                <b-col></b-col>
                                <b-col>
                                    <base-button icon type="info" @click="switchOperationResult(index)">
                                        <span class="btn-inner--icon">
                                            <i :class="{'ni ni-fat-add':!showOperationLogResults[index], 'ni ni-fat-delete':showOperationLogResults[index]}" />
                                        </span>
                                    </base-button>
                                </b-col>
                                <b-row></b-row>
                            </b-row>
                            <template v-if="showOperationLogResults[index]">
                                <result-table v-if="log.result!==undefined && log.result!==null" :data="log.result"></result-table>
                                <p v-else>Loading...</p>
                            </template>
                            
                            <b-row>
                                <b-col>
                                    <h3>Logs:</h3>
                                </b-col>
                                <b-col></b-col>
                                <b-col></b-col>
                                <b-col>
                                    <base-button icon type="info" @click="switchOperationLog(index)">
                                        <span class="btn-inner--icon">
                                            <i :class="{'ni ni-fat-add':!showOperationLogs[index], 'ni ni-fat-delete':showOperationLogs[index]}" />
                                        </span>
                                    </base-button>
                                </b-col>
                                <b-row></b-row>
                            </b-row>
                            <template v-if="showOperationLogs[index]">
                                <result-table v-if="log.logs!==undefined && log.logs !== null" :data="log.logs"/>
                                <p v-else>Loading logs...</p>
                            </template>
                        </card>
                        
                    </template>
                </card>
            </card>
        </b-container>
    </div>
</template>

<script>
import RepositoryFactory from "@/repositories/RepositoryFactory"
import ResultTable from "@/views/Tables/ResultTable"

const JobHistoryRepository = RepositoryFactory.get('job_history')
const OperationLogRepository = RepositoryFactory.get('operation_log')
const LogRepository = RepositoryFactory.get('log')
const LocationRepository = RepositoryFactory.get('location')

export default {
    name:'job-history',
    components:{
        [ResultTable.name]:ResultTable,
    },
    props:{
        id:String,
    },
    data(){
        return {
            jobHistory:null,
            isLoading:true,
            isDownloading:false,
            showJobResults:false,

            operationLogs:null,
            operationLogsLoading:true,
            showOperationLogResults:null,
            showOperationLogs:null,
        }
        
    },
    created(){
        JobHistoryRepository.get(this.id).then((response) => {
            this.jobHistory=response.data[0];
            if(this.jobHistory.job===null){
                this.jobHistory.job={
                    domain:{
                        domain_address:'Malformed data',
                        name:'Malformed data',
                    }
                }
            }
            this.isLoading=false;
        })
        OperationLogRepository.getWithJobId(this.id).then((response) => {
            this.operationLogs=response.data;
            this.operationLogs.sort((a,b) => a.id-b.id);

            this.showOperationLogResults=[];
            this.showOperationLogs=[];
            for(var _ in this.operationLogs){
                this.showOperationLogResults.push(false);
                this.showOperationLogs.push(false);
            }
            this.operationLogsLoading=false;
        })
    },
    methods:{
        switchJobResults(){
            this.showJobResults=!(this.showJobResults);
            if(this.showJobResults && (this.jobHistory.result===undefined || this.jobHistory.result===null)){
                JobHistoryRepository.getResult(this.jobHistory.id).then((response) => {
                    this.jobHistory.result=response.data.result===null ? [] : response.data.result;
                    this.$forceUpdate();
                })
            }
            this.$forceUpdate();
        },
        switchOperationResult(index){
            this.showOperationLogResults[index]=!(this.showOperationLogResults[index]);
            if(this.showOperationLogResults[index] && (this.operationLogs[index].result===undefined || this.operationLogs[index].result===null))
                OperationLogRepository.getResult(this.operationLogs[index].id).then((response) => {
                    this.operationLogs[index].result=response.data.result===null ? [] : response.data.result;
                    this.$forceUpdate();
                })
            
            this.$forceUpdate();
        },
        switchOperationLog(index){
            this.showOperationLogs[index]=!(this.showOperationLogs[index]);
            if(this.showOperationLogs[index] && (this.operationLogs[index].logs===undefined || this.operationLogs[index].logs===null))
                LogRepository.get(this.operationLogs[index].id).then((response) => {
                    this.operationLogs[index].logs=response.data;
                    this.$forceUpdate();
                });
            
            this.$forceUpdate();
        },
        downloadResults(){
            this.isDownloading=true;
            LocationRepository.downloadResults(this.jobHistory.id).then((response) => {
                var domainName = this.jobHistory.job.domain.name;
                this.downloadExcelBlob(response, `${domainName} ${this.jobHistory.id}.xlsx`);
                this.isDownloading=false;
            })
        }
    }
}
</script>

<style>

</style>